<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">日常辅助</Breadcrumb-item>
        <Breadcrumb-item>班主任值班表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="70" :show-message="false" label-position="left">
        <Col :xs="12" :sm="8" :md="6">
          <Form-item label="值班日期:">
            <DatePicker @on-change="atimeDateChange" format="yyyy-MM-dd" type="daterange"
                        placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
          </Form-item>
        </Col>
      </Form>
    </div>
    <div class="btn-wrap">
      <Button type="primary" icon="plus-round"
              @click="onAddTime()">新增值班表
      </Button>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/todo/study-duty-list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>

    <Modal title="添加值班" v-model="showAddTimeModal">
      <Form ref="form1" class="form" :model="addTimeReq" :label-width="80">
        <Row>
          <Col :xs="24" :sm="24" :md="12" :lg="12">
            <Form-item label="值班学导">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser" v-model="addTimeReq.adminUserId"/>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <Form-item label="学导">
              <AdminUserMultSelect :status="1" adminGroupCode="userStudyAdviser"
                                   v-model="addTimeReq.adminUserIds"></AdminUserMultSelect>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <Form-item label="时间">
              <Date-picker
                v-model="addTimeReq.dateRange"
                format="yyyy-MM-dd"
                :clearable="true"
                type="daterange"
                placement="bottom-start"
                placeholder="选择日期"
                style="width: 100%"
                :options="{ disabledDate: disabledDate }"/>
            </Form-item>
          </Col>
        </Row>
      </Form>

      <div slot="footer">
        <Button type="text" size="large" @click="showAddTimeModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="saveTime">保存</Button>
      </div>
    </Modal>

  </div>
</template>
<script>
import AdminUserMultSelect from '../common/AdminUserMultSelect.vue'
import dates from '@/tools/date/dates.js'

export default {
  components: {AdminUserMultSelect},
  data () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        nickname: '',
        mobile: '',
        phone: ''
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      loadingEdit: false,
      showAdminUserEditModal: false,
      showAddTimeModal: false,
      addTimeReq: {
        dateRange: [],
        adminUserIds: [],
      },
      editAdminUser: {
        id: null,
        password: '',
        nickname: '',
        mobile: '',
        phone: '',
        status: '',
        groupId: '',
        agentMoor: '',
        teamType: '',
        positionType: '',
        dingtalkUserid: '',
        isReceiveMsg: '',
        dingtalkDepartmentId: '',
        adminConfig: {
          limitBindTchNum: '',
          limitBindTimeNum: '',
          limitBindTimesMonth: '',
        }
      },
      ruleAdminUser: {
        nickname: [
          {type: 'string', required: true, message: '昵称不能为空', trigger: 'blur'},
          {type: 'string', max: 20, message: '登录账号不能超过20个字', trigger: 'blur'}
        ],
        mobile: [
          {type: 'string', required: true, message: '登录账号不能为空', trigger: 'blur'},
          {type: 'string', max: 30, message: '登录账号不能超过30个字', trigger: 'blur'}
        ],
        phone: [
          {type: 'string', required: true, message: '联系号码不能为空', trigger: 'blur'}
        ],
        groupId: [
          {type: 'integer', required: true, message: '请选择分组', trigger: 'blur'}
        ]
      },
      editPermissionModal: false,
      permissionData: [],
      title: [
        {
          title: '值班日期',
          align: 'center',
          key: 'date'
        },
        {
          title: '值班人员',
          align: 'center',
          key: 'dutyUser'
        },
        {
          title: '小组成员',
          align: 'center',
          render: (h, params) => {
            let dutyUsers = params.row.dutyUsers
            return h('div', dutyUsers.map(user => user.nickname).join('、'))
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                on: {
                  click: () => {
                    this.onDel(params.row.id)
                  }
                }
              }, '删除'),
            ])
          }
        }
      ]
    }
  },
  mounted: function () {
    this.loadAdminGroup()
  },
  created: function () {
  },
  methods: {
    exportData () {
      this.exportLoading = true
      this.$http.get('/adminUser/list-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '每月绑定老师次数统计.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    },
    onAddTime () {
      this.showAddTimeModal = true
    },
    onDel (id) {
      let self = this
      self.$http.get('/todo/del-duty?id=' + id).then(function (res) {
        if (!res || !res.data) {
          self.search()
        }
      })
    },
    saveTime () {
      let self = this
      self.loadingEdit = true
      if (self.addTimeReq.dateRange.length === 2) {
        if (self.addTimeReq.dateRange[0]) {
          let startTimeDate = dates.format(this.addTimeReq.dateRange[0])
          self.addTimeReq.startTime = Date.parse(startTimeDate) / 1000
        } else {
          self.$Message.warning('请选择时间!')
          self.loadingEdit = false
          return
        }
        if (this.addTimeReq.dateRange[1]) {
          self.addTimeReq.endTime = this.$moment(this.addTimeReq.dateRange[1], 'YYYY-M-D H:m').format('X')
        } else {
          self.$Message.warning('请选择时间!')
          self.loadingEdit = false
          return
        }
      } else {
        self.$Message.warning('请选择时间!')
        self.loadingEdit = false
        return
      }
      self.$http.post('/adminUser/add-time', self.addTimeReq).then(function (res) {
        if (res && res.status === 'ok') {
          self.addTimeReq = {}
          self.$Message.success('提交成功!')
          self.search()
        }
        self.loadingEdit = false
      })
    },
    edit () {
      let self = this
      self.loadingEdit = true
      self.$refs.form.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingEdit = false
          return
        }
        let path = '/adminUser/update'
        if (!this.editAdminUser.id || this.editAdminUser.id === '') {
          path = '/adminUser/insert'
        }
        self.$http.post(path, self.editAdminUser).then(function (res) {
          if (res && res.data > 0) {
            self.showAdminUserEditModal = false
            self.$Message.success('提交成功!')
            self.search()
          }
          self.loadingEdit = false
        })
      })
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    loadAdminGroup () {
      let self = this
      if (self.adminGroupList) {
        return
      }
      self.$http.get('/adminGroup/listByCondition?status=1').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.adminGroupList = res.data
      })
    },
    loadDingTalkGroup () {
      let self = this
      self.$http.get('/dingTalk/departmentList').then(function (res) {
        if (!res || !res.data) {
          return
        }
        self.departmentList = res.data
      })
    },
    loadDingtalkUser (val) {
      let self = this
      if (val) {
        self.$http.get('/dingTalk/getUserListByDepartmentId?departmentId=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.userList = res.data
        })
      }
    },
    atimeDateChange (value) {
      this.queryParam.startDate = value[0]
      this.queryParam.endDate = value[1]
      this.search()
    },
    editPermission () {
      let permissions = this.$refs.permissionTree.getCheckedNodes().map(item => item.id).join(',')

      this.loadingEdit = true
      let path = '/adminRuleExtend/saveAdminGroupExtend'

      this.$http.post(path, {uid: this.permissionGroupId, extendId: permissions}).then(res => {
        if (res && res.data > 0) {
          this.editPermissionModal = false
          this.$Message.success('提交成功!')
        }
        this.loadingEdit = false
      })
    },
    onEditPermission (row) {
      this.checkKeys = []
      if (!row || !row.id) {
        return
      }
      this.permissionGroupId = row.id
      this.$http.get('/adminRule/queryAdminRuleDetailByParam', {
        params: {
          type: 'adminUser',
          objectId: row.id
        }
      }).then(res => {
        if (!res || !res.data) {
          return
        }
        this.permissionData = res.data.map(item => {
          return this.treeNode(item)
        })

        this.editPermissionModal = true
      })
    },
    addCheckKeys (permissionDto) {
      if (permissionDto) {
        if (permissionDto.havePermission) {
          this.checkKeys.push(permissionDto.id)
        }
      }
    },
    disabledDate(date) {
      // 禁用今天及之前的所有日期
      return date && date.valueOf() <= Date.now() - 24 * 60 * 60 * 1000;
    },
    treeNode (permissionDto) {
      if (!permissionDto) {
        return
      }
      this.addCheckKeys(permissionDto)
      let treeNode = {
        id: permissionDto.id,
        label: permissionDto.title,
        expand: true,
        checked: permissionDto.havePermission,
        children: []
      }
      if (permissionDto.childAdminRuleDtoList) {
        treeNode.children = permissionDto.childAdminRuleDtoList.map(item => {
          return this.treeNode(item)
        })
      }

      return treeNode
    },
  }
}

</script>

<style lang="less" scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// StudyDutyList.vue?498d1715